export const LEAD_GENERATION_VERTICALS = {

  OZEMPIC: "ozempic",

  TALCUM: "talcum powder",

  DUPIXENT: "dupixent",

  DEPO_PROVERA: "depoprovera",

  HERNIA_MESH: "hernia-mesh",

  SSDI: "SSDI",

  ROBLOX: "roblox-addiction",

  RIDESHARE: "rideshare",

  HAIR_RELAXER: "hair-relaxer",

  ROUNDUP: "roundup",

  SOCIAL_MEDIA_ADDICTION: "social-media-addiction",

  MOTOR_VEHICLE_ACCIDENTS: "motor-vehicle-accidents",

  SEXUAL_ABUSE: "sexual-abuse",

  MESOTHELIOMA : 'mesothelioma',

  TOXIC_BABY_FOOD: 'toxic-baby-food',

  PARAQUAT: 'paraquat',

  AFFF: 'afff',

  ULTRA_PROCESSED_FOOD: 'ultra-processed-food',

  OXBRYTA: 'oxbryta',

  PFAS: 'pfas',

  NEC: 'nec',

  BARD_POWERPORT: 'bard-powerport',

  SUBOXONE: 'suboxone',

  TESLA_AUTOPILOT_RECALL: 'tesla-autopilot-recall',

  EIGHTEEN_WHEELER_ACCIDENT: '18-wheeler-accident'

};

 